import { parsePhoneNumberFromString } from "libphonenumber-js";

export const sampleContactPayload = (form, country = "US") => {
  const email = form.email.trim();
  const phone = form.phone.trim();
  if (!email && !phone) throw new Error("Enter an email address or phone number. Either one is enough.");
  const contact = email ? { email } : {};
  if (phone) {
    const parsed = parsePhoneNumberFromString(phone, phone.startsWith("+") ? undefined : country);
    if (!parsed?.isPossible()) throw new Error("Enter a valid phone number. For international numbers, include + and the country code.");
    contact.phone = parsed.number;
  }
  return contact;
};